import { Button } from "primereact/button";
import { Defect } from "../../types/defect";
import { useAppDispatch, useAppSelector } from "../../hooks/storeHooks";
import { setToEditImages } from "../../store/slices/defectSlice";
import { useCallback } from "react";
import { selectLoadingImages } from "../../store/selectors/inspectionSelectors";
import addImages from "../../assets/addImages.svg";
import { ViewImagesButton } from "../Shared/ViewImagesButton";

export const DefectTableImagesBody = (defect: Defect) => {
    const dispatch = useAppDispatch();

    const loadingImages = useAppSelector(selectLoadingImages);

    const onEditImages = useCallback(() => {
        dispatch(setToEditImages(defect));
    }, [defect]);

    if (loadingImages) {
        return <span className="pi pi-spin pi-spinner" />;
    }

    return (
        <div className="flex">
            <ViewImagesButton item={defect} />
            <Button
                rounded
                text
                onClick={onEditImages}
                tooltip="Select images"
                tooltipOptions={{ position: "top" }}
            >
                <img className="custom-icon" src={addImages} alt="add-images" />
            </Button>
        </div>
    );
};
